import { t } from "@lingui/macro";
import * as React from "react";
import { Rect, Ellipse, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const DollarBillIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Dollar Bill`} {...props}>
    <Rect width={14} height={10} x={1} y={3} fill="currentColor" rx={1.5} />
    <Ellipse cx={8} cy={8} fill="#F5F5F5" rx={1.5} ry={2} />
    <Path
      fill="#F5F5F5"
      d="M2 10a2 2 0 0 1 2 2H2.5a.5.5 0 0 1-.5-.5V10ZM14 11.5a.5.5 0 0 1-.5.5H12a2 2 0 0 1 2-2v1.5ZM4 4a2 2 0 0 1-2 2V4.5a.5.5 0 0 1 .5-.5H4ZM13.5 4a.5.5 0 0 1 .5.5V6a2 2 0 0 1-2-2h1.5Z"
    />
  </Icon>
);
